(function (factory) {
    typeof define === 'function' && define.amd ? define(['kendo.core'], factory) :
    factory();
})((function () {
    (function( window, undefined$1 ) {
        kendo.cultures["ar-TD"] = {
            name: "ar-TD",
            numberFormat: {
                pattern: ["-n"],
                decimals: 2,
                ",": ",",
                ".": ".",
                groupSize: [3],
                percent: {
                    pattern: ["-n%","n%"],
                    decimals: 2,
                    ",": ",",
                    ".": ".",
                    groupSize: [3],
                    symbol: "%"
                },
                currency: {
                    name: "Central African CFA Franc",
                    abbr: "XAF",
                    pattern: ["-$ n","$ n"],
                    decimals: 0,
                    ",": ",",
                    ".": ".",
                    groupSize: [3],
                    symbol: "FCFA"
                }
            },
            calendars: {
                standard: {
                    days: {
                        names: ["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],
                        namesAbbr: ["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],
                        namesShort: ["أحد","إثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"]
                    },
                    months: {
                        names: ["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],
                        namesAbbr: ["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"]
                    },
                    AM: ["ص","ص","ص"],
                    PM: ["م","م","م"],
                    patterns: {
                        d: "d/M/yyyy",
                        D: "dddd، d MMMM yyyy",
                        F: "dddd، d MMMM yyyy h:mm:ss tt",
                        g: "d/M/yyyy h:mm tt",
                        G: "d/M/yyyy h:mm:ss tt",
                        m: "d MMMM",
                        M: "d MMMM",
                        s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
                        t: "h:mm tt",
                        T: "h:mm:ss tt",
                        u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
                        y: "MMMM yyyy",
                        Y: "MMMM yyyy"
                    },
                    "/": "/",
                    ":": ":",
                    firstDay: 1
                }
            }
        };
    })();

}));
